module.exports = __webpack_public_path__ + "static/media/Info.198aa8b3.svg";